module.exports = __webpack_public_path__ + "img/logo-installment-thai-qr.7d0e7fca.png";